
import { Component, Vue, Prop } from 'nuxt-property-decorator';

@Component
export default class Wait extends Vue {
  @Prop({ type: String, required: true }) readonly for!: string;

  get isWaiting() {
    return this.$wait.is(this.for);
  }
}
